import React from 'react';

const ViewImage = () => {
    return (
        <div className="box view">
        </div>
    );
}
export default ViewImage;

